import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ContractsTable from './ContractsTable';

import { modalOptions } from 'Helpers/modalOptions';

import Modal from 'CommonComponents/Modal';

import useApiRequest from 'Hooks/useApiRequest';
import useModal from 'Hooks/useModal';

const SponsortierContractsModal = ({ fetchRevenueContractsUrl }) => {
    const [sponsortierId, setSponsortierId] = useState(document.getElementById('SponsortierContractsModalApp').getAttribute('data-sponsortier-id'));
    const [contracts, setContracts] = useState([]);

    const modal = useModal({
        options: {
            ...modalOptions(true),
            backdrop: 'dynamic',
        },
    });

    const sponsortierContractsRequest = useApiRequest({
        url: fetchRevenueContractsUrl,
    });

    useEffect(() => {
        const targetNode = document.getElementById('SponsortierContractsModalApp');

        // Callback function to execute when mutations are observed
        const callback = function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes') {
                    if (mutation.attributeName === 'data-sponsortier-id') {
                        const newSponsortierId = mutation.target.getAttribute('data-sponsortier-id');
                        setSponsortierId(newSponsortierId);

                        modal.show();
                    }
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, { attributes: true });

        // Cleanup function to stop observing when the component unmounts
        return () => {
            observer.disconnect();
        };
    }, [contracts]);

    useEffect(() => {
        setContracts(sponsortierContractsRequest.data?.data || []);
    }, [sponsortierContractsRequest.data]);

    useEffect(() => {
        if (sponsortierId) {
            fetchContracts(sponsortierId);
        }
    }, [sponsortierId]);

    const fetchContracts = (sponsortierId = null) => {
        sponsortierContractsRequest.get(null, { SPONSORTIER_ID: sponsortierId });
    };

    return (
        <Modal id="sponsortier-contracts-modal" modal={modal} innerContainerClasses="tw-bg-[#F8F8F8]" containerStyle={{ maxWidth: 'none', width: 'auto' }}>
            <ContractsTable isLoading={sponsortierContractsRequest.loading} contracts={contracts} />
        </Modal>
    );
};

if (document.getElementById('SponsortierContractsModalApp')) {
    var rootEl = document.getElementById('SponsortierContractsModalApp');
    var fetchRevenueContractsUrl = rootEl.getAttribute('data-fetch-sponsortier-contracts-url');
    ReactDOM.render(
        <App>
            <SponsortierContractsModal fetchRevenueContractsUrl={fetchRevenueContractsUrl} />
        </App>,
        rootEl,
    );
}
